import classNames from 'classnames';
import { Popover, Listbox } from '@shopify/polaris';
import React__default, { useState } from 'react';
import styles from './Dropdown.scss.mjs';
import SelectedCheckmark from './icons/selected-checkmark.svg.mjs';
import { Button } from '../Button/Button.mjs';

const Dropdown = ({
  activator,
  items,
  disabled,
  onSelect,
  onOpen,
  onClose
}) => {
  const [active, setActive] = useState(false);
  const {
    accessibilityLabel,
    icon,
    tooltip
  } = activator;
  const [selectedItemValue, setSelectedItemValue] = useState();
  const activeItem = items.find(item => item.isActive);
  const activatorButton = /*#__PURE__*/React__default.createElement(Button, {
    disclosure: true,
    tooltip: tooltip,
    onAction: () => {
      if (!active) {
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        setSelectedItemValue(activeItem === null || activeItem === void 0 ? void 0 : activeItem.value);
      }
      setActive(active => !active);
    },
    icon: icon,
    disabled: disabled,
    active: active,
    ariaExpanded: active,
    accessibilityLabel: accessibilityLabel
  });
  return /*#__PURE__*/React__default.createElement(Popover, {
    active: active,
    activator: activatorButton,
    autofocusTarget: "first-node",
    onClose: () => {
      onClose === null || onClose === void 0 ? void 0 : onClose();
      setActive(false);
    }
  }, /*#__PURE__*/React__default.createElement(Listbox, {
    onSelect: value => {
      onSelect(value);
      setActive(false);
    },
    onActiveOptionChange: value => {
      setSelectedItemValue(value);
    },
    enableKeyboardControl: true
  }, items.map(item => {
    const {
      id,
      value,
      content,
      accessibilityLabel,
      isActive
    } = item;
    const isSelected = value === selectedItemValue;
    return /*#__PURE__*/React__default.createElement(Listbox.Option, {
      key: id,
      value: value,
      divider: true,
      accessibilityLabel: accessibilityLabel,
      selected: isSelected
    }, /*#__PURE__*/React__default.createElement("div", {
      className: classNames(styles.ListItem, (isActive || isSelected) && styles.active)
    }, (isActive || isSelected) && /*#__PURE__*/React__default.createElement("div", {
      className: styles.SelectedCheck
    }, isActive && /*#__PURE__*/React__default.createElement(SelectedCheckmark, null)), content));
  })));
};

export { Dropdown };
